module.exports = __webpack_public_path__ + "img/welcome.a1e1ed37.svg";